import {Window , Quicklink, ScrollReset} from "./obj.js"
import discord from "./icons/ic_baseline-discord.svg"
import instagram from "./icons/mdi_instagram.svg"
import linkedIn from "./icons/mdi_linkedin.svg"
import facebook from "./icons/facebook.svg"
import email from "./icons/email.svg"
import calendar from "./icons/mdi_calendar.svg"
import spcpa from "./icons/SPCPA_white.png"
import notion from "./icons/ri_notion-fill.svg"
import google_driver from "./icons/simple-icons_googledrive.svg"
import github from "./icons/mdi_github.svg"
import dmoj from "./icons/dmoj_white.png"
import vjudge from "./icons/vjudge.svg"
import codeforces from "./icons/simple-icons_codeforces.svg"
import aio from "./icons/aio_white_test.svg"
import leetcode from "./icons/leetcode.svg"
import hackerrank from "./icons/hackerrank.png"
import atcoder from "./icons/atCoder.webp"
import help from "./icons/material-symbols_help-outline.svg"
import article from "./icons/material-symbols_article-outline.svg"
import alg from "./icons/compalg.png"
import geeks from "./icons/gfg-gg-logo.svg"
import zoom from "./icons/simple-icons_zoom.svg"


export function Quicklinks(){
    return(<>
        <ScrollReset/>
        <section className = "linkspage">
            <Window title = "Socials">
                <Quicklink src = {discord} path = '/discord'>Discord</Quicklink>
                <Quicklink src = {instagram} path = '/instagram'>Instagram</Quicklink>
                <Quicklink src = {linkedIn} path = '/linkedin'>LinkedIn</Quicklink>
                <Quicklink src = {facebook} path = '/facebook'>Facebook</Quicklink>
            </Window>
            <Window title = "Utility">
                <Quicklink src = {email} path = '/email-list'>Email List</Quicklink>
                <Quicklink src = {calendar} path = '/calendar'>Calendar</Quicklink>
                <Quicklink src = {spcpa} path = 'https://sppcontests.org/'>SPCPA</Quicklink>
                <Quicklink src = {notion} path = '/notion'>Notion (members)</Quicklink>
                <Quicklink src = {google_driver} path = '/google-drive'>Google Drive (members)</Quicklink>
                <Quicklink src = {github} path = '/github'>Github (members)</Quicklink>
                <Quicklink src = {zoom} path = '/zoom'>Zoom</Quicklink>
            </Window>
            <Window title = "Competition Sites">
                <Quicklink src = {dmoj} path = '/dmoj'>Maps DMOJ</Quicklink>
                <Quicklink src = {vjudge} path = '/vjudge'>Maps Vjudge</Quicklink>
                <Quicklink src = {spcpa} path = 'https://prog4fun.csse.canterbury.ac.nz/'>SPAR Judge</Quicklink>
                <Quicklink src = {codeforces} path = 'https://codeforces.com/'>Codeforces</Quicklink>
                <Quicklink src = {aio} path = 'https://orac2.info/hub/aio/'>AIO</Quicklink>
                <Quicklink src = {leetcode} path = 'https://leetcode.com/'>Leetcode</Quicklink>
                <Quicklink src = {hackerrank} path = 'https://www.hackerrank.com/'>HackerRank</Quicklink>
                <Quicklink src = {atcoder} path = 'https://atcoder.jp/'>AtCoder</Quicklink>
            </Window>
            <Window title = "Training Resources">
                <Quicklink src = {help} path = '/intro-to-cp'>MAPS Intro</Quicklink>
                <Quicklink src = {article} path = '/articles'>MAPS Articles</Quicklink>
                <Quicklink src = {alg} path = 'https://cp-algorithms.com/'>CP-Algorithms</Quicklink>
                <Quicklink src = {geeks} path = 'https://www.geeksforgeeks.org/'>Geeks for Geeks</Quicklink>

            </Window>

        </section>
    </>)
}

export default Quicklinks; 